import { Box } from "@material-ui/core";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { NETWORK } from "src/config/constants";
import { POOL_IDS } from "src/config/poolsConfig";
import { useUserMonitoringSelector } from "src/context/monitoring/userMonitoringContext";
import useTravaUserAction from "src/hooks/useTravaUserAction";
import ActionDataTable from "./ActionDataTable";
import NetApyData from "./NetApyData";

export default function ActionUserData() {
  const { pool } = useParams();
  const network = useMemo(() => {
    if (pool === POOL_IDS.TRAVA_BSC) return NETWORK.BSC_MAINNET;
    else if (pool === POOL_IDS.TRAVA_FTM) return NETWORK.FTM_MAINNET;
    else return NETWORK.ETH_MAINNET;
  }, [pool]);

  const selectedAddress = useUserMonitoringSelector((state) => state.selectedAddress);
  const { totalUserDeposit, totalUserBorrow, actionData, netApy } = useTravaUserAction(selectedAddress, pool, network);

  return (
    <>
      <Box mt={2}>
        <NetApyData {...{ totalUserDeposit, totalUserBorrow, netApy }} />
      </Box>
      <Box mt={3}>
        <ActionDataTable {...{ actionData }} />
      </Box>
    </>
  );
}
